// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-endpoint-group { width: auto; }
.col-endpoint-name { width: auto; }
.col-model-type { width: auto; }
.col-model-provider { width: auto; }
.col-deployment-name { width: auto; }

/* Apply fixed widths only for >= 1536px */
@media (max-width: 1536px) {
  .col-endpoint-group { width: 130px !important; }
  .col-endpoint-name { width: 200px !important; }
  .col-model-type { width: 110px !important; }
  .col-model-provider { width: 150px !important; }
  .col-deployment-name { width: 150px !important; }
}`, "",{"version":3,"sources":["webpack://./src/components/DataTable.css"],"names":[],"mappings":"AAAA,sBAAsB,WAAW,EAAE;AACnC,qBAAqB,WAAW,EAAE;AAClC,kBAAkB,WAAW,EAAE;AAC/B,sBAAsB,WAAW,EAAE;AACnC,uBAAuB,WAAW,EAAE;;AAEpC,0CAA0C;AAC1C;EACE,sBAAsB,uBAAuB,EAAE;EAC/C,qBAAqB,uBAAuB,EAAE;EAC9C,kBAAkB,uBAAuB,EAAE;EAC3C,sBAAsB,uBAAuB,EAAE;EAC/C,uBAAuB,uBAAuB,EAAE;AAClD","sourcesContent":[".col-endpoint-group { width: auto; }\n.col-endpoint-name { width: auto; }\n.col-model-type { width: auto; }\n.col-model-provider { width: auto; }\n.col-deployment-name { width: auto; }\n\n/* Apply fixed widths only for >= 1536px */\n@media (max-width: 1536px) {\n  .col-endpoint-group { width: 130px !important; }\n  .col-endpoint-name { width: 200px !important; }\n  .col-model-type { width: 110px !important; }\n  .col-model-provider { width: 150px !important; }\n  .col-deployment-name { width: 150px !important; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
